import React, { useState, useMemo } from "react";

export default function MenuSection({ menu }) {
  const [active, setActive] = useState("All");

  const items = useMemo(() => {
    if (active === "All") return menu.items;
    return menu.items.filter((i) => i.category === active);
  }, [active, menu.items]);

  return (
    <section id="menu" className="py-24 md:py-32 bg-[#faf3e3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[12px] tracking-tight-wide text-[#a08862] font-semibold">
            {menu.eyebrow}
          </p>
          <h2 className="font-serif-display text-4xl md:text-6xl text-[#2a2a2a] mt-4">
            {menu.title}
          </h2>
          <div className="divider-line" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12">
          {menu.categories.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`px-5 py-2 text-[12px] tracking-tight-wide transition-all duration-300 ${
                active === c
                  ? "bg-[#a08862] text-white"
                  : "bg-transparent text-[#2a2a2a] border border-[#a08862]/40 hover:bg-[#a08862]/10"
              }`}
            >
              {c.toUpperCase()}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((item) => (
            <div
              key={item.id}
              className="bg-[#f5ebd6] overflow-hidden group transition-shadow duration-300 hover:shadow-xl"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 bg-white text-[#2a2a2a] text-sm font-medium px-3 py-1 rounded-sm shadow">
                  ₹{item.price}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-serif-display text-2xl text-[#2a2a2a] mb-2">
                  {item.name}
                </h3>
                <p className="text-sm text-[#5a5a5a] leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
